import React from 'react';
import styled from 'styled-components';
import { InteractiveStyle } from './layout';

export const ResultsIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M8.14141 13.3681C8.30236 13.7662 8.36166 14.0627 8.36166 14.4439C8.36166 15.9687 7.12489 17.1969 5.60859 17.1969C4.09228 17.1969 2.84705 15.9602 2.84705 14.4439C2.84705 14.0881 2.8894 13.7916 3.03341 13.4443C3.29601 12.8767 5.634 9.09021 5.634 9.09021C5.634 9.09021 7.98046 12.9699 8.14141 13.3681Z"
        fill="white"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.9326 8.47185C21.0936 8.86999 21.1529 9.16647 21.1529 9.54766C21.1529 11.0724 19.9161 12.3007 18.3998 12.3007C16.875 12.3007 15.6467 11.064 15.6467 9.54766C15.6467 9.19188 15.6891 8.8954 15.8331 8.54809C16.0957 7.98053 18.4337 4.194 18.4337 4.194C18.4337 4.194 20.7717 8.07371 20.9326 8.47185Z"
        fill="white"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.23682 9.5053L20.2635 2.84711"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.73438 21.4833H14.7657"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8009 6.17621V20.8734"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8433 7.2266C12.5732 7.2266 13.1648 6.63495 13.1648 5.90512C13.1648 5.17529 12.5732 4.58365 11.8433 4.58365C11.1135 4.58365 10.5219 5.17529 10.5219 5.90512C10.5219 6.63495 11.1135 7.2266 11.8433 7.2266Z"
        fill="white"
        stroke="black"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ConditioningIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 20.9058C16.8325 20.9058 20.75 16.9185 20.75 12C20.75 7.0814 16.8325 3.09412 12 3.09412C7.16751 3.09412 3.25 7.0814 3.25 12C3.25 16.9185 7.16751 20.9058 12 20.9058Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.56666 10.7362C3.18333 7.4198 2.175 4.48511 3.275 3.33159C4.075 2.49189 5.84166 2.77179 8.025 3.89987"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.975 15.7064C21.1917 17.9626 21.5417 19.8116 20.7167 20.6683C19.1584 22.2883 14 19.7268 9.18337 14.9346C8.63337 14.3918 8.10837 13.832 7.6167 13.2806"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CuriousIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M8.27365 21.1667C8.77891 19.0333 9.87365 17.5583 11.4736 16.7083C9.78944 16 8.59365 14.6 7.88628 12.5333C7.38102 14.6667 6.28628 16.125 4.68628 16.975C6.37049 17.6833 7.56628 19.0917 8.27365 21.1667Z"
      fill="white"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7936 12.2417C21.5452 15.5917 21.6715 18.775 19.7852 20.2917C17.9578 21.775 14.7157 21.3 11.4736 19.3667"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.2884 9.6C2.4884 7.09167 2.74103 4.89167 4.2063 3.7C6.86735 1.55 12.501 3.525 16.8042 8.10834C17.2926 8.63334 17.7558 9.16667 18.1684 9.70834"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.10726 13.275C4.82094 12.85 4.56831 12.425 4.33252 12"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ChevronDownIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 10}
      height={height || 5}
      viewBox="0 0 10 5"
      fill="none"
      {...props}
    >
      <path
        d="M1.5 1L5 4l3.5-3"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OneTrustIcon = (props) => {
  let { height, width } = props;
  return (
    <img
      src="images/privacyicon.svg"
      role="presentation"
      alt=""
      loading="lazy"
      {...props}
    ></img>
  );
};

const RawFacebookIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M15.117 0H.883A.883.883 0 000 .883v14.233c0 .489.395.884.883.884h7.663V9.805H6.46V7.388h2.085v-1.78c0-2.066 1.262-3.191 3.104-3.191.886 0 1.643.065 1.865.095V4.67h-1.28c-1.003 0-1.198.479-1.198 1.178v1.54h2.391l-.312 2.416h-2.079V16h4.079a.884.884 0 00.884-.884V.883A.884.884 0 0015.117 0z"
        fill="#fff"
      />
    </svg>
  );
};

export const FacebookIcon = styled(RawFacebookIcon)`
  ${InteractiveStyle}
  :hover {
    transition: all 0.15s linear 0s;
    opacity: 0.5;
  }
`;

const RawInstagramIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.054 0h11.893C15.077 0 16 .924 16 2.054v11.893c0 1.13-.925 2.053-2.053 2.053H2.054a2.06 2.06 0 01-2.053-2.055V2.053A2.06 2.06 0 012.054 0zm9.602 1.778a.722.722 0 00-.72.72v1.724c0 .396.324.72.72.72h1.807c.398 0 .721-.324.721-.72V2.498a.722.722 0 00-.72-.72h-1.808zm2.537 4.988h-1.409c.135.435.206.896.206 1.373 0 2.661-2.226 4.819-4.973 4.819s-4.973-2.157-4.973-4.82c0-.476.072-.937.206-1.372H1.78v6.759c0 .35.286.636.636.636h11.14c.35 0 .636-.286.636-.636V6.766zM8.016 4.851c-1.775 0-3.213 1.395-3.213 3.114 0 1.72 1.438 3.114 3.213 3.114 1.775 0 3.213-1.393 3.213-3.114 0-1.719-1.438-3.114-3.213-3.114z"
        fill="#fff"
      />
    </svg>
  );
};

export const InstagramIcon = styled(RawInstagramIcon)`
  ${InteractiveStyle}
  :hover {
    transition: all 0.15s linear 0s;
    opacity: 0.5;
  }
`;

const RawPinterestIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8 0a8 8 0 00-3.212 15.327c-.022-.559-.003-1.228.139-1.835.155-.65 1.03-4.36 1.03-4.36S5.7 8.62 5.7 7.865c0-1.184.688-2.07 1.543-2.07.729 0 1.08.546 1.08 1.2 0 .732-.468 1.826-.707 2.84-.2.847.426 1.54 1.263 1.54 1.515 0 2.535-1.948 2.535-4.253 0-1.754-1.18-3.066-3.327-3.066-2.427 0-3.939 1.81-3.939 3.832 0 .697.206 1.188.527 1.569.148.175.168.244.115.445-.039.148-.127.502-.163.642-.053.202-.217.276-.4.201-1.117-.457-1.638-1.68-1.638-3.056 0-2.272 1.916-4.998 5.717-4.998 3.055 0 5.063 2.21 5.063 4.583 0 3.138-1.743 5.483-4.315 5.483-.864 0-1.676-.468-1.955-.998 0 0-.464 1.843-.563 2.199-.169.617-.502 1.233-.805 1.715A8 8 0 108.001 0z"
        fill="#fff"
      />
    </svg>
  );
};

export const PinterestIcon = styled(RawPinterestIcon)`
  ${InteractiveStyle}
  :hover {
    transition: all 0.1s linear 0s;
    opacity: 0.7;
  }
`;

const RawTwitterIcon = (props) => {
  let { height, width, fill } = props;
  return (
    <svg
      width={width || 16}
      height={height || 14}
      viewBox="0 0 16 14"
      fill="none"
      {...props}
    >
      <path
        d="M16 2.037a6.552 6.552 0 01-1.885.518A3.302 3.302 0 0015.559.739a6.602 6.602 0 01-2.085.797A3.283 3.283 0 007.88 4.53a9.32 9.32 0 01-6.767-3.431 3.284 3.284 0 001.016 4.383 3.278 3.278 0 01-1.486-.41l-.001.041a3.285 3.285 0 002.633 3.219 3.303 3.303 0 01-1.482.056 3.286 3.286 0 003.066 2.28A6.584 6.584 0 010 12.028a9.287 9.287 0 005.031 1.474c6.04 0 9.341-5.001 9.341-9.34 0-.142-.003-.283-.01-.424A6.68 6.68 0 0016 2.037z"
        fill="#fff"
      />
    </svg>
  );
};

export const TwitterIcon = styled(RawTwitterIcon)`
  ${InteractiveStyle}
  :hover {
    transition: all 0.15s linear 0s;
    opacity: 0.5;
  }
`;

const RawYoutubeIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.251 2.328c.689.181 1.23.714 1.415 1.39C16 4.943 16 8 16 8s0 3.057-.334 4.282a1.986 1.986 0 01-1.415 1.39C13.003 14 8 14 8 14s-5.003 0-6.251-.328a1.986 1.986 0 01-1.415-1.39C0 11.057 0 8 0 8s0-3.057.334-4.282a1.986 1.986 0 011.415-1.39C2.997 2 8 2 8 2s5.003 0 6.251.328zM11.5 8L6 11V5l5.5 3z"
        fill="#fff"
      />
    </svg>
  );
};

export const YoutubeIcon = styled(RawYoutubeIcon)`
  ${InteractiveStyle}
  :hover {
    transition: all 0.15s linear 0s;
    opacity: 0.5;
  }
`;

export const GlossierLogo = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 32}
      viewBox="0 0 24 32"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.84 17.4l-.003-7.886c0-1.01-.827-.955-1.37-.638-1.899 1.1-5.596 3.306-6.105 3.548-.38.18-.646.488-.646.949 0 1.148.168 2.686.168 3.98 0 1.97-.313 3.493-1.782 4.305-.89.488-2.377.368-3.723-.982-4.447-4.467-1.313-15.168 9.983-16.798.241-.033.435-.067.593-.093.263-.04.465-.228.465-.502 0-.23-.16-.404-.366-.484l-.346-.134c-.598-.22-5.362-1.922-6.965-2.519C13.14-.079 12.354.01 12.09.063-1.907 3.1-3.713 19.978 6.477 26.619c.108.07.559.343 1.055.055 1.386-.8 5.416-3.193 7.076-4.099 3.566-1.946 6.206-1.657 7.502.112.882 1.208.805 2.897.023 3.93-.944 1.248-2.7 1.405-3.612.375-.674-.762-1.839-1.387-3.034-1.154-1.283.245-2.404 1.134-2.549 2.549-.168 1.672.987 3.134 2.709 3.49 3.842.8 8.207-2.384 8.207-7.633l-.003-1.934c-.005-1.433-.01-3.174-.01-4.91z"
        fill="#fff"
      />
    </svg>
  );
};

const RawGlossierNavigationLogo = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 78}
      height={height || 20}
      viewBox="0 0 78 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.463 6.551c-.518-2.637-2.268-4.52-5.438-4.55L8.95 2h-.061c-3.618.021-6.299 1.838-7.725 4.551C.403 7.995 0 9.692 0 11.507c0 3.485 1.934 5.68 4.404 6.294.472.118.964.178 1.465.178.593 0 1.127-.06 1.61-.178 1.045-.254 1.848-.777 2.474-1.54v1.382a.16.16 0 00.151.158h2.137a.162.162 0 00.147-.124l1.476-7.55v-.002a.16.16 0 00-.155-.203H8.32a.16.16 0 00-.156.13l-.405 2.045a.156.156 0 00.01.093.16.16 0 00.145.098h2.708c-.58 1.607-1.942 3.013-4.084 3.013-2.165 0-3.526-1.562-3.526-4.218 0-1.738.554-3.357 1.52-4.532.944-1.148 2.281-1.873 3.88-1.873 1.505 0 2.378.685 2.965 1.873.143.29.27.61.383.957l.002.006a.16.16 0 00.193.093l2.43-.637a.161.161 0 00.12-.182 9.587 9.587 0 00-.043-.237zM20.41 2.161a.16.16 0 00-.16-.16h-.001L20.247 2H17.785a.16.16 0 00-.157.133l-2.995 15.473a.165.165 0 00.009.097.16.16 0 00.148.098h2.462a.16.16 0 00.156-.12l2.999-15.494c.001-.008.003-.017.003-.026zM27.763 14.408c-.58.759-1.384 1.205-2.477 1.205-1.317 0-2.187-1.07-2.187-2.811 0-1.206.267-2.143.825-2.857.58-.759 1.384-1.205 2.477-1.205 1.317 0 2.188 1.07 2.188 2.812 0 1.205-.268 2.142-.826 2.856zm.346-7.857a5.862 5.862 0 00-1.462-.177c-.644 0-1.22.054-1.756.177-1.043.24-1.927.739-2.841 1.608-1.34 1.295-1.92 2.946-1.92 5.066 0 2.2 1.271 4.017 3.445 4.576.45.116.94.178 1.465.178.645 0 1.223-.055 1.76-.178 1.04-.24 1.924-.739 2.837-1.608 1.34-1.294 1.92-2.945 1.92-5.065 0-2.2-1.272-4.019-3.447-4.577zM40.806 8.168v-.002c-.375-.734-1.224-1.332-2.21-1.615a4.482 4.482 0 00-1.233-.177c-.522 0-1 .06-1.43.177-1.575.425-2.498 1.594-2.498 3.26 0 1.495.982 2.365 2.299 2.99 1.272.603 1.92 1.005 1.92 1.652 0 .803-.67 1.16-1.43 1.16-1.063 0-1.821-.649-2.142-1.753a.16.16 0 00-.214-.096l-2.072.86v.002a.161.161 0 00-.099.148l.003.024c.273 1.113 1.151 2.515 2.875 3.003.4.113.844.178 1.338.178.562 0 1.092-.058 1.576-.178 1.705-.421 2.842-1.607 2.842-3.728 0-1.562-1.16-2.32-2.32-2.856-.76-.357-1.942-.692-1.942-1.473 0-.647.49-1.004 1.093-1.004.582 0 1.24.27 1.635.849a.16.16 0 00.212.04h.001l1.737-1.25a.075.075 0 00.013-.01l.004-.002a.161.161 0 00.042-.199zM47.79 6.551a4.484 4.484 0 00-1.234-.177c-.522 0-1 .06-1.43.177-1.575.425-2.498 1.594-2.498 3.26 0 1.495.981 2.365 2.298 2.99 1.272.603 1.92 1.005 1.92 1.652 0 .803-.67 1.16-1.429 1.16-1.066 0-1.826-.652-2.145-1.76a.16.16 0 00-.213-.088l-2.07.86a.161.161 0 00-.099.149c0 .01.002.02.004.03.274 1.113 1.153 2.51 2.873 2.997.4.113.844.178 1.338.178.562 0 1.092-.058 1.577-.178 1.704-.421 2.842-1.607 2.842-3.728 0-1.562-1.16-2.32-2.321-2.856-.76-.357-1.942-.692-1.942-1.473 0-.647.49-1.004 1.093-1.004.58 0 1.238.27 1.633.845a.16.16 0 00.215.044l1.758-1.265a.159.159 0 00.04-.196c-.376-.735-1.225-1.334-2.21-1.617zM55.001 6.553h-2.466a.16.16 0 00-.153.114l-2.126 10.935v.002a.161.161 0 00.157.197h2.462c.03 0 .06-.01.084-.024a.158.158 0 00.071-.095l2.13-10.956.002-.012A.16.16 0 0055 6.553zM58.913 10.882c.468-1.16 1.584-2.142 2.99-2.142 1.406 0 2.053.736 2.142 2.142h-5.132zm4.773-4.33a5.514 5.514 0 00-1.426-.178c-.57 0-1.11.062-1.618.177-3.137.712-5.055 3.474-5.055 6.451 0 2.576 1.376 4.27 3.393 4.8.447.116.926.177 1.428.177.608 0 1.16-.06 1.667-.178 1.567-.365 2.71-1.298 3.77-2.827a.16.16 0 00-.052-.219l-1.944-1.001a.159.159 0 00-.064-.016.16.16 0 00-.124.06c-.808 1.162-1.73 1.815-3.008 1.815-1.473 0-2.276-1.026-2.276-2.187v-.357h7.957a.16.16 0 00.154-.113 7.99 7.99 0 00.28-2.074c0-2.078-1.06-3.792-3.082-4.33zM75.775 9.065a.02.02 0 01.007.002.16.16 0 00.225-.079l.813-2.168v-.002a.161.161 0 00-.085-.211 5.076 5.076 0 00-.15-.056c-.345-.121-.647-.177-1.157-.177-.404 0-.806.056-1.2.177-.825.252-1.616.785-2.326 1.675l.295-1.475a.16.16 0 00-.156-.198H69.58a.16.16 0 00-.158.13v.001l-2.125 10.929a.163.163 0 00.01.09.161.161 0 00.148.098h2.463a.16.16 0 00.156-.123l.757-3.872c.67-3.549 2.589-4.955 3.972-4.955.385 0 .708.076.972.214z"
        fill="#1A1919"
      />
      <mask
        id="prefix__a"
        maskUnits="userSpaceOnUse"
        x={52}
        y={2}
        width={26}
        height={16}
      >
        <path d="M52.684 2.175h24.82V18h-24.82V2.175z" fill="#fff" />
      </mask>
      <g
        mask="url(#prefix__a)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1A1919"
      >
        <path d="M54.268 2.175c-.91 0-1.584.693-1.584 1.585 0 .891.673 1.584 1.584 1.584.912 0 1.585-.693 1.585-1.584 0-.892-.673-1.585-1.585-1.585zM75.92 14.846c-.912 0-1.586.694-1.586 1.585 0 .593.298 1.098.766 1.37.235.137.514.215.82.215.304 0 .582-.078.818-.215a1.56 1.56 0 00.766-1.37c0-.891-.674-1.585-1.585-1.585z" />
      </g>
    </svg>
  );
};

export const GlossierNavigationLogo = styled(RawGlossierNavigationLogo)`
  ${InteractiveStyle}
`;

export const NourishingIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M16.183 6.525c0-2.042-1.491-3.692-3.333-3.692-1.675 0-3.058 1.375-3.292 3.167h-.075C9.25 4.208 7.867 2.833 6.192 2.833c-1.842 0-3.334 1.65-3.334 3.692 0 .967.342 1.842.892 2.5l5.775 7.517L15.3 9.025c.55-.658.883-1.533.883-2.5z"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.183 13.517c0-1.467-1.075-2.659-2.4-2.659-1.208 0-2.2.992-2.366 2.275h-.059c-.166-1.283-1.158-2.275-2.366-2.275-1.325 0-2.4 1.192-2.4 2.659 0 .691.242 1.325.641 1.8l4.159 5.408 4.158-5.408a2.83 2.83 0 00.633-1.8z"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CourageousIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0)"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.65 16.542c.892-3.35 2.6-5.617 5.008-6.867C10.225 8.45 8.55 6.158 7.65 2.833c-.892 3.35-2.6 5.592-5.008 6.842 2.425 1.233 4.1 3.542 5.008 6.867zM17.308 21.133c.6-2.266 1.759-3.8 3.392-4.65-1.642-.833-2.775-2.383-3.392-4.633-.6 2.267-1.758 3.783-3.392 4.633 1.642.834 2.776 2.4 3.392 4.65z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DiscerningIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M14.167 2.835l-7.332 9.779 4.885 1.219-1.22 7.332 7.333-9.779-4.885-1.219 1.219-7.332z"
          fill="#fff"
          stroke="#000"
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(6 2)" d="M0 0h12.668v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BalancingIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0)"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M8.141 13.368a2.753 2.753 0 01-2.533 3.829 2.766 2.766 0 01-2.761-2.753c0-.356.042-.652.186-1 .263-.567 2.601-4.354 2.601-4.354s2.346 3.88 2.507 4.278zM20.933 8.472a2.753 2.753 0 11-5.286 1.076c0-.356.042-.653.186-1 .263-.567 2.6-4.354 2.6-4.354s2.339 3.88 2.5 4.278z"
          fill="#fff"
        />
        <path d="M3.237 9.505l17.026-6.658M8.734 21.483h6.032M11.8 6.176v14.697" />
        <path
          d="M11.843 7.227a1.322 1.322 0 100-2.643 1.322 1.322 0 000 2.643z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(2 2)" d="M0 0h20v20.33H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FlexibleIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M10.942 10.675l-1.017 9.75c-.025.225.142.425.342.425l2.825-.458c.208 0 .366-.2.341-.425l-.608-9.292c-.042-.458-1.842-.458-1.883 0z"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.575 10.117l1.459-.525M3.667 6.175C7.183 6.6 9.225 8.133 10.9 9.95M7.142 8.992L8.6 8.467M5.367 7.792l1.45-.525M3.7 14.858c2.384-2.616 4.825-3.383 7.275-3.7M9.759 13.15l.416-1.483M8.009 13.658l.416-1.483M6 14.417l.417-1.492M13.942 8.717l-1.534.225M16.425 2.933c-2.908 2.025-3.992 4.342-4.617 6.725M14.675 7.05l-1.533.225M15.683 5.158l-1.533.217M20.092 11.125c-3.225-1.458-5.767-1.2-8.142-.508M13.85 11.958l-.975-1.2M15.659 11.733l-.975-1.2M17.8 11.625l-.975-1.2"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RefiningIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M21.167 8.417L17.35 2.833H6.65L2.833 8.417l9.1 12.75 9.234-12.75z"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.833 8.417h18.334M11.933 21.167L7.975 8.417l2.242-5.584M11.933 21.167l3.884-12.75-2.034-5.584"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BuildableIcon = (props) => {
  let { height, width } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M2.833 21.167L12 2.833l9.167 18.334H2.833z"
        fill="#fff"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 19.033v-4.05 4.05z" fill="#fff" />
      <path
        d="M9 19.033v0zm0 0v-4.05 4.05z"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
      <path d="M15.083 19.033v-4.05 4.05z" fill="#fff" />
      <path
        d="M15.083 19.033v0zm0 0v-4.05 4.05z"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
      <path
        d="M9.167 9.2h5.666M6.017 15.183h11.966"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.925v0zm0 0v-3.25 3.25z"
        stroke="#000"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16">
      <path d="M9.1 8l4.5-4.5c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L8 6.9 3.5 2.5c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1L6.9 8l-4.5 4.5c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2L8 9.1l4.5 4.5c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1L9.1 8z"></path>
    </svg>
  );
};
